export const departmentList = "DEPARTMENT_LIST";